export default "__VITE_ASSET__DnWHgf44__"